import { Select, Typography } from '@execonline-inc/execonline-ui';
import { noop } from '@kofno/piper';
import { observer } from 'mobx-react';
import { T } from '../../../../Translations';

type FilterOption = 'Competency' | 'Time Commitment' | 'Partner' | 'Language';
const filterOptions: FilterOption[] = ['Competency', 'Time Commitment', 'Partner', 'Language'];
interface Props {
  disabled: boolean;
}
function Filters({ disabled }: Props) {
  return (
    <div className="flex basis-7/12 gap-2">
      {filterOptions.map((option) => (
        <Select
          key={option}
          className="w-1/4"
          multiple
          disabled={disabled}
          value={[]}
          renderValue={() => (
            <span className="flex gap-x-2 overflow-hidden">
              <Typography
                variant="bodyMedium"
                className="overflow-hidden text-ellipsis whitespace-nowrap"
                as="span"
              >
                <T kind={option} />
              </Typography>
            </span>
          )}
          onChange={noop}
        />
      ))}
    </div>
  );
}

export default observer(Filters);
